export default [
  {
    path: '',
    name: 'bandeja',
    component: () => import(/* webpackChunkName: "bandeja" */ '@/apps/bandeja/pages/BandejaPage.vue')
  }
]
